import { createContext } from 'react';

export const FingerprintContext = createContext();
